module.exports = __webpack_public_path__ + "static/media/5-item-d.bb43b3df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/5-item-d.jpg
// module id = 1175
// module chunks = 33